import { useContext } from 'react';
import { AuthContext } from '../providers/auth.js';

const useAuthClient = () => {
  const authData = useContext(AuthContext);
  return authData;
};

export { useAuthClient };
//# sourceMappingURL=use-auth.js.map
